import React from 'react';
import store from '../store';
import debugDispatcher from '../utils/debugDispatcher';
import globalFocus from '../utils/globalFocus';
import { Url } from '../utils/util';
import setAppShortcuts from './setAppShortcuts';
import { globals } from '@apia/util';

export function reloadStyles(selector: string) {
  const elements = [
    ...window.parent.document.head.querySelectorAll(selector),
  ] as HTMLLinkElement[];

  elements.forEach((element) => {
    let href = element?.href;

    if (!href) return;

    if (href.match(/t=/)) {
      href = href.replace(/t=\d+/, `t=${Date.now()}`);
    } else href = `${href}?t=${Date.now()}`;

    // eslint-disable-next-line no-param-reassign
    element.href = href;
  });
}

export function setMainCommands() {
  document.addEventListener('keydown', (ev) => {
    if (
      window.top !== window &&
      globals?.getVersion()?.env === 'development' &&
      ev.code === 'F5'
    ) {
      ev.stopPropagation();
      ev.preventDefault();
      window.location.reload();
      console.clear();
    }
  });

  window.Version = `${globals} ${
    globals?.getVersion()?.env === 'development'
      ? globals?.getVersion()?.env
      : ''
  }`;
  debugDispatcher.on(
    'test',
    ([shouldTest]: any) => {
      sessionStorage.setItem(
        'putTestsToWork',
        String(
          shouldTest === 'true' ||
            sessionStorage.getItem('putTestsToWork') !== 'true',
        ),
      );
      window.location.reload();
    },
    'Acepta un booleano que establece el modo test de la aplicación.',
  );
  debugDispatcher.on(
    'redux',
    ([selector]: any) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any
      console.info((selector as any)(store.getState()));
    },
    'Permite el pasaje de una función selectora para mostrar información del store',
  );
  debugDispatcher.on(
    'develop',
    ([shouldDevelop]: any) => {
      const isDevelopment =
        shouldDevelop !== undefined
          ? !shouldDevelop
          : globals?.getVersion()?.env === 'development';

      const newUrl = new Url(window.location.href, false);
      newUrl.addParameter('develop', !isDevelopment);

      location.href = newUrl.toString();
    },
    'Acepta un booleano que establece el modo desarrollo de la aplicación.',
  );

  setAppShortcuts();
}

export const getTemplateName = (): string => {
  const str = window.TEMPLATE_NAME;
  const regex = /\/([^/]*)\.jsp$/;
  const tempName = str?.match(regex);
  if (tempName) return tempName[1];
  return '';
};

export function shoutAppInformation() {
  console.info(
    `%c Build: ${window.Version} | Template: ${getTemplateName()}`,
    'background: #cce5ff; color: #004085; margin: 4px; padding: 4px',
  );
  console.info({
    appliedTheme: window.appliedTheme,
    baseTheme: window.baseTheme,
    customTheme: window.customTheme && window.customTheme(),
  });
}

export function useAppEventListeners() {
  React.useEffect(() => {
    const handleFocus = (e: FocusEvent) => {
      globalFocus.focus = e.target as HTMLElement;
    };
    document.addEventListener('focusin', handleFocus);
    return () => document.removeEventListener('focusin', handleFocus);
  }, []);
}

interface IIterationCount {
  count: number;
  maxIterations: number;
}
const counters: Record<string, IIterationCount> = {};
/**
 * Permite limitar la cantidad de veces que se ejecuta un script.
 *
 * **Está pensada con propósitos de desarrollo**
 *
 * Cuando un script entra en bucle, puede ser importante limitar la cantidad
 * de veces que se ejecuta para que el navegador no quede colgado.
 *
 * @param name Un identificador único
 * @param maxIterations La cantidad máxima de veces que el proceso puede
 * ejecutar.
 */
export function limitIterations(name: string, maxIterations: number) {
  if (!counters[name]) counters[name] = { count: 0, maxIterations };
  counters[name].count++;
  if (counters[name].count > counters[name].maxIterations)
    throw new Error(`Max iterations raised on ${name}`);
}
